<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_SUB_INDUSTRY_ID'
        )
      }"
    >
      <select
        v-model="$parent.project.UF_SUB_INDUSTRY_ID"
        class="sel-dropdown i-main-style i-wid-29"
        v-on:change="
          $parent.$parent.removeError('PROJECTS', 'LOGIC', 'UF_SUB_INDUSTRY_ID')
        "
        :disabled="is_disabled || $parent.$parent.projectDisabled"
      >
        <option value=""></option>
        <option
          v-for="item in subIndustry"
          v-bind:value="item.ID"
          v-bind:key="item.ID"
          v-text="item.NAME"
        ></option>
      </select>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_SUB_INDUSTRY_ID"
          )
        }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "uf_sub_industry_id",
  props: {
    is_disabled: false
  },
  computed: {
    subIndustry() {
      if (this.$parent.project.UF_INDUSTRY_ID < 1) {
        return [];
      }
      let t = this.$parent.directory.tree_industry.filter(
        c => c.ID === this.$parent.project.UF_INDUSTRY_ID
      );
      if (t.length > 0) {
        return t[0].CHILD;
      }
      return [];
    }
  }
};
</script>

<style scoped></style>
